const PHONE = '561-445-3948';

const painPoints = [
  {
    icon: 'ri-home-4-line',
    problem: 'Tired of a dirty roof making your home look 20 years older?',
    solution: 'Soft-wash roof cleaning removes black streaks, algae & mold in one visit.',
  },
  {
    icon: 'ri-file-warning-line',
    problem: 'Getting HOA violation notices about your roof or driveway?',
    solution: 'We\'ll make your property HOA-compliant — fast, before your deadline.',
  },
  {
    icon: 'ri-road-map-line',
    problem: 'Driveway full of stains that scrubbing just won\'t remove?',
    solution: 'Professional-grade pressure cleaning lifts what household tools can\'t touch.',
  },
  {
    icon: 'ri-water-percent-line',
    problem: 'Worried about high-pressure cleaning damaging your roof or screens?',
    solution: 'We use the right pressure for every surface — no damage, guaranteed.',
  },
];

export default function PainPointSection() {
  return (
    <section className="bg-slate-900 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <span className="inline-block bg-white/10 text-slate-300 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Sound Familiar?
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4">
            You Don't Need Replacement.
            <span className="text-teal-400"> You Need Professional Cleaning.</span>
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            We hear these frustrations every week from South Florida homeowners.
            The fix is simpler — and cheaper — than you think.
          </p>
        </div>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-12">
          {painPoints.map((item, i) => (
            <div
              key={i}
              className="bg-slate-800/60 border border-slate-700 rounded-2xl p-6"
            >
              {/* Problem */}
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-red-500/20 shrink-0">
                  <i className={`${item.icon} text-red-400 text-lg`}></i>
                </div>
                <p className="text-slate-200 font-semibold text-base leading-snug">&ldquo;{item.problem}&rdquo;</p>
              </div>
              {/* Solution */}
              <div className="flex items-start gap-3 pl-0">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-teal-600 shrink-0 mt-0.5">
                  <i className="ri-check-line text-white text-xs"></i>
                </div>
                <p className="text-teal-300 text-sm font-medium leading-relaxed">{item.solution}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-slate-400 text-base mb-5">
            Stop living with it. One call and we'll handle everything.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="#contact"
              className="bg-orange-500 hover:bg-orange-600 text-white font-black text-lg px-8 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              See What We Can Do — Free Estimate
            </a>
            <a
              href={`tel:${PHONE}`}
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/15 border border-white/20 text-white font-bold text-lg px-8 py-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-orange-400 text-base"></i>
              </div>
              {PHONE}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
